/* eslint-disable @typescript-eslint/no-explicit-any */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Fragment } from "react";
import {
  DropEvent,
  DropzoneOptions,
  FileRejection,
  useDropzone,
} from "react-dropzone";
import { useFormatMsg } from "../../../../hooks/useFormatMsg";
import useClipboardPaste from "./useClipboardPaste";
import { noop } from "../../../../globalConsts";
import { activeWrapperCss, wrapperCss } from "./Dropzone.styles";
import { applyCss } from "../../../../utils/emotion";
import { useOnReject } from "./utils";

// jako normální onDropRejected z libky, ale vrací bool. Když vrátí true,
// tak se neprovádí defaultní reject logika - viz utils/useDropReject
type CustomDropReject = (
  fileRejections: FileRejection[],
  event: DropEvent
) => boolean | void;

export type CustomDropzoneOptions = Omit<DropzoneOptions, "onDropRejected"> & {
  onDropRejected?: CustomDropReject;
};

// POZOR: asi je důležité do options posílat stabilní reference, protože
// to tak dělají ve všech tutorialech na webu
export type Props = CustomDropzoneOptions & {
  className?: string;
  pasteListenerTarget: HTMLElement | null;
  acceptedTypesLabel?: string; // Uživatelsky čitelné pojmenování akceptovatelných typů
};

const Dropzone: FC<Props> = ({
  className,
  pasteListenerTarget,
  acceptedTypesLabel,
  ...dropzoneOptions
}) => {
  const formatMsg = useFormatMsg();

  const { accept } = dropzoneOptions;

  const onReject = useOnReject(dropzoneOptions);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    ...dropzoneOptions,
    onDropRejected: onReject,
  });

  const { onDropAccepted = noop } = dropzoneOptions;
  const pasteCallback = (files: File[]) => onDropAccepted(files, null as any);
  useClipboardPaste(pasteListenerTarget, pasteCallback);

  return (
    <Fragment>
      <div
        {...getRootProps()}
        css={applyCss([wrapperCss, isDragActive && activeWrapperCss])}
      >
        <input enterKeyHint="done" {...getInputProps()} />
        {formatMsg("file_dropzone.label")}

        {accept && <br />}
        {accept &&
          formatMsg("file_dropzone.accepted_types", {
            types: acceptedTypesLabel || accept,
          })}
      </div>
    </Fragment>
  );
};

export default Dropzone;
export type DropzoneProps = Props;
